<div class="standardpanel">
  <div class="titleblock">
    <h3 class="title1level">Petitum</h3>
  </div>
  <div class="container_dati_generali" *ngIf="tipoPetitumOptions$ | async as tipoPetitumOptions">
    <form [formGroup]="formGroup" *ngIf="formGroup">
      <div class="row">
        <div class="col-sm-12">
          <div radioButtonInput [radioButtonOptions]="tipoPetitumOptions" [nameRadio]="'tipoPetitum'"
            [checkedRadioId]="formGroup.get('tipoPetitum').value?.id"
            (onReturn)="formGroup.get('tipoPetitum').setValue($event)" [statoEntitaTemplate]="true"
            [statoTemplateTitle]="'Tipo petitum'"></div>
        </div>
      </div>
      <div class="row" *ngIf="petitum && petitum.tipoPetitum &&  petitum.tipoPetitum.id ==='QUANTIFICABILE'">
        <div class="col-sm-6">
          <div datePickerInput [labelInput]="'Data inizio calcolo Interessi'" [mandatory]="true"
            [formControlName]="'dataInizioCalcoloInteressi'"
            [control]="formGroup.controls['dataInizioCalcoloInteressi']"
            [submitPending]="formGroup.get('dataInizioCalcoloInteressi').disabled"></div>
        </div>
        <div class="col-sm-6">
          <div textInputCurrency class="{{suggested ? 'component-suggested' : ''}}" [labelInput]="'Importo'"
            formControlName="importoPetitum" [location]="'SezioneEconomica'"
            [control]="formGroup.controls['importoPetitum']" [ngModel]="petitum.importoPetitum" (ngModelChange) = "retrieveImporto($event)">
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
